import { render, staticRenderFns } from "./TeamGames.vue?vue&type=template&id=3c5ead9c&"
import script from "./TeamGames.vue?vue&type=script&lang=ts&"
export * from "./TeamGames.vue?vue&type=script&lang=ts&"
import style0 from "./TeamGames.vue?vue&type=style&index=0&id=3c5ead9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports